<template>
  <v-card class="mx-auto" outlined elevation="24" shaped rounded color="#96298A">
          <v-card-text>            
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col cols="12" class="text-subtitle-1 text-center">
                Actualizando POD por favor espere...
              </v-col>
              <v-col cols="12">
                <v-progress-linear
                  color="#FC8333"                  
                  rounded
                  height="50"
                  v-model="value"
                >
                <template v-slot:default="{ value }">
                <strong>{{ Math.ceil(value) }}%</strong>
                </template>
                </v-progress-linear>
              </v-col>              
              <v-col cols="12" class="text-subtitle-1 text-center">
                Guia Buscada {{guiaCreada}}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
</template>
<script>
export default {
props:{
    totalGuias: {
      type: Number,
      default: 0
    },
    currentGuia: {
        type: Number,
        default: 0
    },
    guiaCreada: {
        type: String,
        default: null
    }    
},
watch:{
    currentGuia: function(val){
        if(val){
            this.value = (val / this.totalGuias) * 100;
        }
    }
},
data() {
    return{
        value: 0
    }
},
methods:{    
},
mounted: function(){

}
}
</script>

<style>

</style>